<template>
    <v-container fluid>
        <SimpleDataTable
            :headers="headers"
            :items="dataTable"
            table-title="table title"
            :config-column="true"
            @show-column="toggleColumn($event, true)"
            @hide-column="toggleColumn($event)"
        >
            <template v-slot:action="props">
                <v-icon small>mdi-play</v-icon>
                <v-icon small>edit</v-icon>
                <v-icon small>delete</v-icon>
                <v-icon small>mdi-download</v-icon>
            </template>
        </SimpleDataTable>
    </v-container>
</template>
<script>
import SimpleDataTable from '@/components/SimpleDataTable'

export default {
    name      : 'CustomerDataTable',
    components: {SimpleDataTable},
    data() {
        let dataTable = []
        for (let i = 0; i < 20; i++) {
            dataTable.push({
                user          : 'Lê Hồng Dũng ' + i,
                date          : '18:00 20-08-2019',
                numberOfRecord: '0912345678',
                test1         : '1111',
                test2         : '2222',
                test3         : '3333'
            })
        }
        return {
            dataTable: dataTable,
            headers  : [
                {
                    text    : this.$filters.capitalize(this.$t('user')),
                    value   : 'user',
                    sortable: false
                },
                {
                    text    : this.$filters.capitalize(this.$t('date')),
                    value   : 'date',
                    sortable: false
                },
                {
                    text    : this.$filters.capitalize(this.$t('numberOfRecord')),
                    value   : 'numberOfRecord',
                    sortable: false
                },
                {
                    text     : this.$filters.capitalize(this.$t('test 1')),
                    value    : 'test1',
                    sortable : false,
                    invisible: true
                },
                {
                    text     : this.$filters.capitalize(this.$t('test 2')),
                    value    : 'test2',
                    sortable : false,
                    invisible: true
                },
                {
                    text     : this.$filters.capitalize(this.$t('test 3')),
                    value    : 'test3',
                    sortable : false,
                    invisible: true
                },
                {
                    text    : this.$filters.capitalize(this.$t('action')),
                    type    : 'action',
                    sortable: false
                }
            ]
        }
    },
    methods   : {
        toggleColumn(column, visible) {
            this.headers = this.headers.map(header => {
                if (header.value && header.value === column) {
                    visible ? header.invisible = false : header.invisible = true
                }
                return header
            })
        }
    }
}
</script>
